export default __webpack_public_path__ + "static/qt-sweetcombe-marque-5-star-gold-rgb-bbcd84af55879c3b940f59040aa74712.png";